import { render, staticRenderFns } from "./image-upload.vue?vue&type=template&id=23916d6d&"
import script from "./image-upload.vue?vue&type=script&lang=ts&"
export * from "./image-upload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports